import { render, staticRenderFns } from "./sendMsg.vue?vue&type=template&id=5d675084&scoped=true&"
import script from "./sendMsg.vue?vue&type=script&lang=js&"
export * from "./sendMsg.vue?vue&type=script&lang=js&"
import style0 from "./sendMsg.vue?vue&type=style&index=0&id=5d675084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d675084",
  null
  
)

export default component.exports